import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { PopupTriggerProps } from '@atlassian/jira-development-board-common/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/ui/branch-details-popup-view/__generated__/BranchDetailsPopupViewQuery$parameters';
import type { BranchDetailsPopupViewQuery } from './src/ui/branch-details-popup-view/__generated__/BranchDetailsPopupViewQuery.graphql';

/**
 * @deprecated This component is deprecated. Please use the component from
 * "@atlassian/jira-development-board-branch-details-popup-new" package instead.
 */
export const branchDetailsEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			branchDetailsForIssue: BranchDetailsPopupViewQuery;
		},
		{},
		PopupTriggerProps,
		{}
	>,
	{
		issueId: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-branch-details-popup" */ './src/ui/branch-details-popup-view/BranchDetailsPopupView.tsx'
			),
	),
	getPreloadProps: ({ issueId }: { issueId: string }) => ({
		queries: {
			branchDetailsForIssue: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					issueId,
				},
			},
		},
	}),
});
